import * as excel from '@attain-apps/excel'
import { saveAs } from 'file-saver'

/** @see {@link Blob.type} */
const EXCEL_BLOB_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
const EXCEL_EXTENSION = '.xlsx'

/**
 * Adds browser-only file-saving on top of the platform-neutral
 * {@link excel.Workbook}
 */
export class Workbook extends excel.Workbook {
  /**
   * Saves this {@link Workbook} to the given file name
   */
  public async saveAs(fileName: string): Promise<void> {
    if (!fileName.endsWith(EXCEL_EXTENSION)) {
      // Adds the extension if it is not already on the file name
      fileName += EXCEL_EXTENSION
    }

    const data = await this.toBuffer()
    // NOTE: type-only cast, no runtime effect — Uint8Array<ArrayBufferLike>
    // isn't a BlobPart because ArrayBufferLike also covers SharedArrayBuffer,
    // which Blob's constructor type rejects, even though the actual value
    // here is a plain, Blob-constructable Uint8Array
    const blob = new Blob([data as unknown as BlobPart], {
      type: EXCEL_BLOB_TYPE,
    })
    saveAs(blob, fileName)
  }
}
